// CIVICSUPPLY 2026-08-15 - Standalone "Request a Quote" modal logic (v3).
// Companion to snippets/civicsupply-quote-form.liquid + civicsupply-quote-row.liquid.
//
// v3 REDESIGNS THE SHELL, NOT THE ENGINE. Everything downstream is untouched:
// same contact-pipe submit, same "=== QUOTE REQUEST V1 ===" payload that
// phase2-quote-automation.gs parses into a draft order, same localStorage
// draft, same discount tiers, same capture-phase validation (see the long note
// by the submit handler - that one is load-bearing, do not move it).
//
// What changed here vs v2 (2026-08-14):
//   - Category ACCORDIONS became FILTER CHIPS. openGroups/suppressToggleRecord
//     and the capture-phase `toggle` listener are gone with them; the catalogue
//     is now one continuous list that gets narrowed rather than four drawers
//     that get opened.
//   - A sticky footer + header pill + mobile bar all read the same totals, so
//     the running figure is on screen at every width.
//   - The contact fields dim until the quote holds something (syncChrome).
//   - On phones the quote pane is a slide-up SHEET rather than a second screen
//     below the catalogue.
//
// Later the same day (Denis): the header strapline came out, every product
// photo became a real link to its product page, and the TYPED CONTACT DETAILS
// are now persisted alongside the quantities - see saveFields() for why that
// second change made the third one necessary.
//
// The DOM is the catalogue. Liquid renders every card; this file reads titles,
// images, prices and variant ids off the data-cs-* attributes and never keeps
// its own copy - so adding a product in Shopify needs no change here.
(function () {
  var PENDING_KEY = 'civicsupplyQuotePending';
  var DRAFT_KEY = 'civicsupplyQuoteDraft';
  var FIELDS_KEY = 'civicsupplyQuoteFields';

  var qty = {};            // variantId -> quantity
  var tiers = [];          // discount tiers, from the Liquid config block
  var currency = 'CAD';
  var activeCat = 'all';   // which category chip is pressed
  var memFallback = null;  // used when localStorage throws (Safari private mode)
  var memFieldsFallback = null;
  var lastOpener = null;   // restores keyboard focus when the modal closes

  function modal() { return document.getElementById('civicsupply-quote-form-modal'); }
  function qtyInputs() { return modal().querySelectorAll('[data-cs-qty]'); }
  function cards() { return modal().querySelectorAll('[data-cs-row]'); }
  function sections() { return modal().querySelectorAll('[data-cs-section]'); }
  function chips() { return modal().querySelectorAll('[data-civicsupply-quote-chip]'); }
  function dialog() { return modal().querySelector('[data-civicsupply-qf-dialog]'); }

  function setBackgroundInert(isInert) {
    var page = document.querySelector('.page-wrapper');
    if (!page) return;
    if (isInert) page.setAttribute('inert', '');
    else page.removeAttribute('inert');
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s == null ? '' : String(s);
    return div.innerHTML;
  }
  // escapeHtml alone is not enough for an attribute value - innerHTML leaves
  // quotes untouched, so a value containing one could break out of the attribute.
  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, '&quot;');
  }

  // ---------------------------------------------------------------- config
  function readConfig() {
    // NOTE: the config block is a sibling of the modal, not a child - query the
    // document, not modal(). (Scoping it to modal() silently produced tiers=[]
    // and a discount-free total, caught in testing 2026-08-14.)
    var el = document.querySelector('[data-civicsupply-quote-config]');
    if (!el) return;
    try {
      var cfg = JSON.parse(el.textContent);
      tiers = cfg.tiers || [];
      currency = cfg.currency || 'CAD';
    } catch (err) {
      // Tiers unreadable -> show no discount rather than a wrong one. The draft
      // order applies the real discounts regardless.
      tiers = [];
    }
  }

  // ------------------------------------------------------------- persistence
  function saveDraft() {
    var json = JSON.stringify(qty);
    try { localStorage.setItem(DRAFT_KEY, json); } catch (err) { memFallback = json; }
  }
  function loadDraft() {
    var raw = null;
    try { raw = localStorage.getItem(DRAFT_KEY); } catch (err) { raw = memFallback; }
    if (!raw) return {};
    var parsed;
    try { parsed = JSON.parse(raw); } catch (err) { return {}; }
    // Keep only variants that still exist on the page - a deleted product must
    // not come back as a phantom line.
    var clean = {};
    qtyInputs().forEach(function (input) {
      var id = input.dataset.csVariant;
      if (parsed[id] > 0) clean[id] = parsed[id];
    });
    return clean;
  }

  // ---- typed contact details survive closing AND leaving the page ----------
  // Added 2026-08-15 with the clickable product photos (Denis: "the preference
  // in the modal should not be deleted when it closes"). Quantities already
  // survived - they autosave to DRAFT_KEY on every change and close() only
  // hides the modal - but the TYPED FIELDS lived only in the DOM, so the new
  // photo links would have wiped a half-filled form on every navigation.
  // Cleared on submit, same as the draft, so contact details are not left
  // sitting in storage after the quote has gone.
  function formFieldEls() {
    var form = document.getElementById('CivicsupplyQuoteForm');
    if (!form) return [];
    return Array.prototype.slice.call(
      form.querySelectorAll('[name^="contact["]:not([type="hidden"])')
    );
  }
  function saveFields() {
    var data = {};
    formFieldEls().forEach(function (f) { if (f.value) data[f.name] = f.value; });
    var json = JSON.stringify(data);
    try { localStorage.setItem(FIELDS_KEY, json); } catch (err) { memFieldsFallback = json; }
  }
  function loadFields() {
    var raw = null;
    try { raw = localStorage.getItem(FIELDS_KEY); } catch (err) { raw = memFieldsFallback; }
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (err) { return; }
    formFieldEls().forEach(function (f) {
      if (data[f.name] != null) f.value = data[f.name];
    });
  }
  function clearFields() {
    try { localStorage.removeItem(FIELDS_KEY); } catch (err) {}
    memFieldsFallback = null;
  }

  // ------------------------------------------------------------------ totals
  function lines() {
    var out = [];
    qtyInputs().forEach(function (input) {
      var id = input.dataset.csVariant;
      var n = qty[id] || 0;
      if (!n) return;
      var row = input.closest('[data-cs-row]');
      var label = input.closest('[data-cs-vgroup]').querySelector('[data-cs-vlabel]');
      var price = parseInt(input.dataset.csPrice, 10) || 0;
      out.push({
        id: id,
        qty: n,
        price: price,
        line: n * price,
        title: row.dataset.csTitle,
        img: row.dataset.csImg,
        url: row.dataset.csUrl,
        variant: label ? label.textContent.trim() : ''
      });
    });
    return out;
  }

  function totals() {
    var L = lines(), sub = 0, units = 0;
    L.forEach(function (l) { sub += l.line; units += l.qty; });
    var tier = null;
    for (var i = 0; i < tiers.length; i++) {
      if (sub >= tiers[i].min) { tier = tiers[i]; break; }
    }
    var disc = tier ? Math.round(sub * tier.pct) : 0;
    var next = null;
    for (var j = tiers.length - 1; j >= 0; j--) {
      if (sub < tiers[j].min) { next = tiers[j]; break; }
    }
    return { L: L, units: units, sub: sub, tier: tier, disc: disc, total: sub - disc, next: next };
  }

  // -------------------------------------------------------------- order pad
  function syncCard(input) {
    var id = input.dataset.csVariant;
    var n = qty[id] || 0;
    if (input.value !== String(n)) input.value = n;

    var vrow = input.closest('[data-cs-vgroup]');
    vrow.classList.toggle('civicsupply-qf__vrow--active', n > 0);
    var dec = vrow.querySelector('[data-cs-step="-1"]');
    if (dec) dec.disabled = n === 0;

    var row = input.closest('[data-cs-row]');
    var rowTotal = 0;
    row.querySelectorAll('[data-cs-qty]').forEach(function (i) {
      rowTotal += (qty[i.dataset.csVariant] || 0) * (parseInt(i.dataset.csPrice, 10) || 0);
    });
    row.classList.toggle('civicsupply-qf__card--active', rowTotal > 0);
    var lineEl = row.querySelector('[data-cs-line]');
    if (lineEl) {
      lineEl.textContent = 'Line total ' + money(rowTotal);
      lineEl.hidden = rowTotal === 0;
    }
  }

  function syncAllCards() { qtyInputs().forEach(syncCard); }

  // A chip shows a dot when its category holds a selection, so a customer who
  // has narrowed to "Fittings" can still see that Fire Hose is not empty.
  function syncChips() {
    chips().forEach(function (chip) {
      var cat = chip.dataset.civicsupplyQuoteChip;
      var has = Array.prototype.some.call(cards(), function (row) {
        if (cat !== 'all' && row.dataset.csCat !== cat) return false;
        return Array.prototype.some.call(row.querySelectorAll('[data-cs-qty]'), function (i) {
          return (qty[i.dataset.csVariant] || 0) > 0;
        });
      });
      chip.classList.toggle('civicsupply-qf__chip--has-sel', has);
    });
  }

  // ---------------------------------------------------------------- summary
  function renderSummary() {
    var box = modal().querySelector('[data-civicsupply-quote-items]');
    var t = totals();

    if (!t.L.length) {
      box.innerHTML =
        '<div class="civicsupply-qf__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M4 7h16l-1.2 11.2A2 2 0 0 1 16.8 20H7.2a2 2 0 0 1-2-1.8L4 7Z"/><path d="M9 7V5.5A3 3 0 0 1 15 5.5V7"/></svg>' +
          '<strong>Nothing added yet</strong>' +
          '<span>Set a quantity on any product and it lands here.</span>' +
        '</div>';
      return;
    }

    var rows = t.L.map(function (l) {
      return '<div class="civicsupply-qf__item">' +
          (l.img
            ? (l.url
                ? '<a class="civicsupply-qf__item-img-link" href="' + escapeAttr(l.url) +
                    '" data-cs-product-link aria-label="View ' + escapeAttr(l.title) + '">' +
                    '<img class="civicsupply-qf__item-img" src="' + escapeAttr(l.img) + '" alt="" loading="lazy">' +
                  '</a>'
                : '<img class="civicsupply-qf__item-img" src="' + escapeAttr(l.img) + '" alt="" loading="lazy">')
            : '') +
          '<span class="civicsupply-qf__item-info">' +
            '<span class="civicsupply-qf__item-title">' + escapeHtml(l.title) + '</span>' +
            (l.variant ? '<span class="civicsupply-qf__item-variant">' + escapeHtml(l.variant) + '</span>' : '') +
          '</span>' +
          '<span class="civicsupply-qf__item-qty">&times;&thinsp;' + l.qty + '</span>' +
          '<span class="civicsupply-qf__item-total">' + money(l.line) + '</span>' +
          '<button class="civicsupply-qf__item-remove" type="button" data-civicsupply-quote-remove="' +
            escapeHtml(l.id) + '" aria-label="Remove ' + escapeHtml(l.title) + '">&times;</button>' +
        '</div>';
    }).join('');

    var discount = t.tier
      ? '<div class="civicsupply-qf__trow civicsupply-qf__trow--discount"><span>' + escapeHtml(t.tier.title) +
        '</span><span>&minus;' + money(t.disc) + '</span></div>'
      : '';
    var nudge = t.next
      ? '<p class="civicsupply-qf__nudge">Add <strong>' + money(t.next.min - t.sub) +
        '</strong> more to unlock ' + Math.round(t.next.pct * 100) + '% off your order.</p>'
      : '';

    box.innerHTML =
      '<div class="civicsupply-qf__items-list">' + rows + '</div>' +
      '<div class="civicsupply-qf__totals">' +
        '<div class="civicsupply-qf__trow">' +
          '<span>' + plural(t.L.length, 'line item') + '</span>' +
          '<span>' + plural(t.units, 'unit') + '</span>' +
        '</div>' +
        '<div class="civicsupply-qf__trow"><span>Subtotal</span><span>' + money(t.sub) + '</span></div>' +
        discount +
        '<div class="civicsupply-qf__trow civicsupply-qf__trow--big">' +
          '<span>Estimated total</span>' +
          '<span class="civicsupply-qf__amt">' + money(t.total) + ' ' + currency + '</span>' +
        '</div>' +
        '<p class="civicsupply-qf__tax-note">List pricing, ' + escapeHtml(currency) +
          ', before tax and freight. Applicable taxes and shipping are added to your final quote.</p>' +
      '</div>' +
      nudge;
  }

  // Header pill, sticky footer, mobile bar, submit state and the form gate all
  // read one set of totals, so they can never disagree with each other.
  function syncChrome() {
    var m = modal();
    var t = totals();
    var has = t.L.length > 0;

    var pill = m.querySelector('[data-civicsupply-quote-pill]');
    if (pill) {
      pill.textContent = has
        ? plural(t.L.length, 'item') + ' · ' + money(t.total)
        : 'No items yet';
      pill.classList.toggle('civicsupply-qf__pill--empty', !has);
    }

    var footLabel = m.querySelector('[data-civicsupply-quote-foot-label]');
    var footAmt = m.querySelector('[data-civicsupply-quote-foot-amount]');
    if (footLabel) footLabel.textContent = has ? 'Estimated total' : 'Nothing added yet';
    if (footAmt) footAmt.textContent = money(t.total);

    var mbCount = m.querySelector('[data-civicsupply-quote-mb-count]');
    var mbAmount = m.querySelector('[data-civicsupply-quote-mb-amount]');
    if (mbCount) {
      mbCount.textContent = has
        ? plural(t.L.length, 'item') + ' · ' + plural(t.units, 'unit') +
          (t.tier ? ' · ' + Math.round(t.tier.pct * 100) + '% off' : '')
        : 'No items yet';
    }
    if (mbAmount) mbAmount.textContent = money(t.total) + ' ' + currency;

    var submit = m.querySelector('[data-civicsupply-quote-submit]');
    if (submit) submit.disabled = !has;
    var review = m.querySelector('[data-civicsupply-quote-sheet-open]');
    if (review) review.disabled = !has;

    var clear = m.querySelector('[data-civicsupply-quote-clear]');
    if (clear) clear.hidden = !has;

    // The gate is cosmetic - submit is disabled above regardless, so a dimmed
    // form can never be posted even if a stylesheet fails to load.
    var fields = m.querySelector('[data-civicsupply-quote-fields]');
    if (fields) fields.classList.toggle('civicsupply-qf__fields--locked', !has);
    var hint = m.querySelector('[data-civicsupply-quote-lockhint]');
    if (hint) hint.hidden = has;
  }

  // Machine-readable block for the email body. phase2-quote-automation.gs parses
  // the ITEM lines (variant id + qty are load-bearing); humans read it too.
  // DO NOT change the shape - see the contract note in the Liquid snippet.
  function buildPayload() {
    var t = totals();
    var out = ['=== QUOTE REQUEST V1 ==='];
    t.L.forEach(function (l) {
      out.push('ITEM | ' + l.id + ' | qty ' + l.qty + ' | ' + l.title +
        (l.variant && l.variant !== 'Default Title' ? ' / ' + l.variant : '') +
        ' | ' + money(l.line));
    });
    if (t.tier) out.push('DISCOUNT | ' + t.tier.title + ' | -' + money(t.disc));
    out.push('TOTAL | ' + money(t.total) + ' ' + currency);
    out.push('=== END QUOTE REQUEST ===');
    return out.join('\n');
  }

  function syncPayload() {
    var field = modal().querySelector('[data-civicsupply-quote-payload]');
    if (field) field.value = buildPayload();
  }

  function refresh() {
    syncAllCards();
    syncChips();
    renderSummary();
    syncChrome();
    syncPayload();
    saveDraft();
  }

  // ----------------------------------------------------------------- filter
  // One pass handles BOTH the search box and the category chip - they compose,
  // so searching inside a narrowed category behaves the way it looks like it
  // should.
  function applyFilter() {
    var box = modal().querySelector('[data-civicsupply-quote-filter]');
    var wrap = modal().querySelector('[data-civicsupply-quote-searchwrap]');
    var q = (box.value || '').toLowerCase().trim();
    var any = false;

    if (wrap) wrap.classList.toggle('civicsupply-qf__search--has-val', !!q);

    cards().forEach(function (row) {
      var catHit = activeCat === 'all' || row.dataset.csCat === activeCat;
      var textHit = !q || (row.dataset.csSearch || '').indexOf(q) !== -1;
      var hit = catHit && textHit;
      row.hidden = !hit;
      if (hit) any = true;
    });

    // A section header with nothing under it reads as a broken list.
    sections().forEach(function (s) {
      var visible = Array.prototype.some.call(
        s.querySelectorAll('[data-cs-row]'),
        function (r) { return !r.hidden; }
      );
      s.hidden = !visible;
    });

    modal().querySelector('[data-civicsupply-quote-noresults]').hidden = any;
  }

  function setCategory(cat) {
    activeCat = cat;
    chips().forEach(function (c) {
      c.setAttribute('aria-pressed', String(c.dataset.civicsupplyQuoteChip === cat));
    });
    applyFilter();
    var scroll = modal().querySelector('[data-civicsupply-quote-pad]');
    if (scroll) scroll.scrollTop = 0;
  }

  function clearSearch() {
    var box = modal().querySelector('[data-civicsupply-quote-filter]');
    if (box) box.value = '';
    applyFilter();
    if (box) box.focus();
  }

  // ------------------------------------------------------------- validation
  // Mirrors civicsupply-contact.js: no native popups, empty required fields go
  // maroon (#852837) and clear as soon as the customer types.
  function validate() {
    var bad = [];
    modal().querySelectorAll('[data-civicsupply-qf-required]').forEach(function (f) {
      var empty = !f.value.trim();
      var badEmail = f.type === 'email' && f.value.trim() &&
        !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.value.trim());
      if (empty || badEmail) { f.classList.add('civicsupply-qf__input--error'); bad.push(f); }
      else f.classList.remove('civicsupply-qf__input--error');
    });
    var note = modal().querySelector('[data-civicsupply-qf-errnote]');
    if (bad.length) {
      note.textContent = 'Please complete the highlighted field' + (bad.length > 1 ? 's' : '') + '.';
      note.hidden = false;
      // On phones the fields live in the sheet; if the customer somehow submits
      // from the catalogue view, show them what needs fixing.
      openSheet();
      bad[0].focus();
      return false;
    }
    note.hidden = true;
    return true;
  }

  // ----------------------------------------------------------------- a11y
  function trapFocus(e) {
    if (e.key !== 'Tab' || modal().hidden) return;
    var f = Array.prototype.filter.call(
      modal().querySelectorAll('button,input,select,textarea,summary,[href]'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ------------------------------------------------- mobile quote sheet
  function sheetIsOpen() {
    var d = dialog();
    return !!d && d.classList.contains('civicsupply-qf__dialog--sheet-open');
  }
  function openSheet() {
    var d = dialog();
    if (d) d.classList.add('civicsupply-qf__dialog--sheet-open');
  }
  function closeSheet() {
    var d = dialog();
    if (d) d.classList.remove('civicsupply-qf__dialog--sheet-open');
  }

  // ------------------------------------------------------------ open / close
  function show(state) {
    var m = modal();
    m.querySelector('[data-civicsupply-quote-main]').hidden = state !== 'form';
    m.querySelector('[data-civicsupply-quote-thanks]').hidden = state !== 'thanks';
    // Shrinks the dialog around the compact success card and hides the builder
    // header. Removed again whenever the form is shown, so reopening the modal
    // is always full size. | Added 2026-08-15
    var d = dialog();
    if (d) d.classList.toggle('civicsupply-qf__dialog--thanks', state === 'thanks');
    // EDITED 2026-08-28 - the dialog is `overflow: hidden` but is still
    // script-scrollable, and the off-screen mobile sheet gives it real
    // scrollHeight. Anything that scrolls it leaves the header stranded off the
    // top with no way back, so every open starts from a known-good 0.
    if (d) d.scrollTop = 0;
    m.hidden = false;
    document.documentElement.classList.add('civicsupply-modal-open');
    setBackgroundInert(true);
  }

  function focusInitialControl() {
    var m = modal();
    if (!m || m.hidden) return;
    var filter = m.querySelector('[data-civicsupply-quote-filter]');
    if (filter) filter.focus({ preventScroll: true });
  }

  function open(opener) {
    var m = modal();
    if (!m) return;
    if (opener && typeof opener.focus === 'function') lastOpener = opener;
    else if (document.activeElement && document.activeElement !== document.body) lastOpener = document.activeElement;
    qty = loadDraft();
    refresh();
    applyFilter();
    show('form');
    // EDITED 2026-08-28 - preventScroll: focusing a field lets the browser
    // scroll its ancestors, which can shift the dialog the same way.
    focusInitialControl();
    // The mobile drawer restores focus to its summary as it closes. Refocus the
    // dialog after that transition so keyboard focus never remains behind it.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(focusInitialControl);
    });
  }

  function close(restoreFocus) {
    var m = modal();
    if (!m || m.hidden) return;
    // Belt and braces: the input/change handlers already autosave, but an
    // autofill that fires neither would otherwise be lost on close.
    saveDraft();
    saveFields();
    m.hidden = true;
    closeSheet();
    document.documentElement.classList.remove('civicsupply-modal-open');
    setBackgroundInert(false);

    var opener = lastOpener;
    lastOpener = null;
    if (restoreFocus !== false && opener && opener.isConnected) {
      window.requestAnimationFrame(function () {
        try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
      });
    }
  }

  // Product page AND card "Request Quote" buttons (both rendered by
  // blocks/add-to-cart.liquid - the card version via a card's buy-buttons
  // block on collection/search pages). Reads the CURRENTLY selected variant +
  // quantity from THIS product's own add-to-cart form.
  //
  // Scoped to the closest <product-card> first: a collection/search grid puts
  // MANY cards' forms inside ONE shared .shopify-section, so scoping to the
  // section alone would always grab the FIRST card's form regardless of which
  // card was clicked (caught 2026-08-15 while wiring the card Request Quote
  // button). Falls back to .shopify-section for the product page, which has
  // no <product-card> wrapper but does need the scope for a different reason:
  // the "You may also like" recommendations further down the SAME page render
  // their own separate buy-buttons forms (one per recommended product) and
  // must never be read by mistake. | Added 2026-08-14, scoping fixed 2026-08-15
  function addFromProductPage(btn) {
    var scope = btn.closest('product-card') || btn.closest('.shopify-section') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]');
    var variantInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    var variantId = variantInput && variantInput.value;
    var n = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    if (!variantId || !modal()) return;

    // Merge into the SAVED draft first, then let open() do its normal
    // load-draft dance - avoids duplicating that logic here.
    var draft = loadDraft();
    draft[variantId] = (draft[variantId] || 0) + n;
    qty = draft;
    saveDraft();

    open(btn);

    // Visible confirmation: jump to the category holding the product, then
    // scroll to and briefly highlight the card, so the click reads as more
    // than a silent number bump.
    var input = modal().querySelector('[data-cs-qty][data-cs-variant="' + variantId + '"]');
    if (input) {
      var row = input.closest('[data-cs-row]');
      if (row.hidden) setCategory('all');
      // EDITED 2026-08-28 - was `row.scrollIntoView({ block: 'center' })`, which
      // scrolls EVERY scrollable ancestor, not just the catalogue pane. On mobile
      // the summary pane is `position:absolute; translateY(101%)` INSIDE the
      // dialog, so the dialog's scrollHeight (1576) far exceeds its clientHeight
      // (812) - scrollIntoView therefore scrolled the DIALOG itself to
      // scrollTop 83, dragging the modal header and search bar off the top. The
      // dialog is `overflow: hidden`, which blocks the USER from scrolling but
      // NOT scripts, so the customer could never scroll it back; opening the
      // sheet happened to clamp it to 0, which is why Review-then-back "fixed"
      // it. Scroll the pad container explicitly instead - it is the only
      // element that should move.
      var pad = modal().querySelector('[data-civicsupply-quote-pad]');
      if (pad) {
        var padBox = pad.getBoundingClientRect();
        var rowBox = row.getBoundingClientRect();
        pad.scrollTop += (rowBox.top - padBox.top) - (padBox.height - rowBox.height) / 2;
      }
      row.classList.add('civicsupply-qf__card--flash');
      setTimeout(function () { row.classList.remove('civicsupply-qf__card--flash'); }, 1400);
    }
  }

  // ----------------------------------------------------------------- events
  // Homepage + About Us "Two ways to buy" > Formal quotation card CTA
  // (templates/index.json + page.about-us.json, block key button_xrFdgX).
  // It's a Horizon native `button` block, whose schema has no field for a
  // custom data-attribute, so it's targeted by its block-id CLASS SUFFIX
  // instead - the same pattern CLAUDE.md already documents for text blocks
  // (block.id is `<hash>__<json-key>`, differs per template, so match the
  // suffix to cover both pages with one selector). `link` still points at
  // /pages/contact as a real, useful no-JS fallback - Horizon renders an
  // empty link as `aria-disabled="true"` with no href at all, which would be
  // a dead end for anyone whose JS didn't load. | Added 2026-08-14
  var QUOTE_CTA_SELECTOR = '[class*="__button_xrFdgX"]';

  // EDITED 2026-09-02 - a CLASS hook alongside the data-attribute one, for
  // triggers that live inside BLOG POST CONTENT.
  //
  // ⚠️ Shopify's rich-text post editor STRIPS `data-` attributes when the post
  // is saved from normal (non-code) view. The blog article's "Request quote"
  // button was authored as `<button data-civicsupply-quote-open>`, survived the
  // initial paste in code view, and was then silently stripped the next time
  // Denis saved after inserting photos — leaving a dead button on a live post.
  // `class` survives that same save, so anything a customer can trigger from
  // inside article content must hook on the class, not the attribute.
  //
  // Both are honoured: the attribute still works everywhere the THEME renders
  // the trigger (header nav, product cards), where no editor can touch it.
  var QUOTE_CLASS_SELECTOR = '.civicsupply-quote-open';

  document.addEventListener('click', function (e) {
    if (!modal()) return;

    var openTrigger =
      e.target.closest('[data-civicsupply-quote-open]') ||
      e.target.closest(QUOTE_CLASS_SELECTOR) ||
      e.target.closest(QUOTE_CTA_SELECTOR);
    if (openTrigger) {
      e.preventDefault();
      open(openTrigger);
      return;
    }
    if (e.target.closest('[data-civicsupply-quote-close]')) { close(); return; }

    // Product photo -> product page (Denis 2026-08-15). These are real <a>
    // elements, so DO NOT preventDefault: just close the modal so it isn't
    // sitting over the outgoing page, and let the browser navigate. A modifier
    // or non-left click is opening a background tab, so the modal stays put.
    // Both the quantities and the typed details are persisted first, so coming
    // back finds the quote exactly as it was left.
    var productLink = e.target.closest('[data-cs-product-link]');
    if (productLink) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      saveDraft();
      saveFields();
      close(false);
      return;
    }

    // EDITED 2026-08-15 - backdrop click closes the modal (Denis). Safe to do:
    // quantities autosave to localStorage on every change (saveDraft) and
    // close() only hides the modal - it never resets the form - so typed
    // contact details survive too. Reopening restores both.
    if (e.target.classList.contains('civicsupply-qf__backdrop')) { close(); return; }

    var addToQuoteBtn = e.target.closest('[data-civicsupply-add-to-quote]');
    if (addToQuoteBtn) {
      e.preventDefault();
      addFromProductPage(addToQuoteBtn);
      return;
    }

    if (e.target.closest('[data-civicsupply-quote-sheet-open]')) { openSheet(); return; }
    if (e.target.closest('[data-civicsupply-quote-sheet-close]')) { closeSheet(); return; }
    if (e.target.closest('[data-civicsupply-quote-searchclear]')) { clearSearch(); return; }

    var chip = e.target.closest('[data-civicsupply-quote-chip]');
    if (chip) { setCategory(chip.dataset.civicsupplyQuoteChip); return; }

    if (e.target.closest('[data-civicsupply-quote-clear]')) {
      qty = {};
      refresh();
      return;
    }

    var step = e.target.closest('[data-cs-step]');
    if (step) {
      var input = step.closest('[data-cs-vgroup]').querySelector('[data-cs-qty]');
      var id = input.dataset.csVariant;
      var n = Math.max(0, (qty[id] || 0) + parseInt(step.dataset.csStep, 10));
      if (n) qty[id] = n; else delete qty[id];
      refresh();
      return;
    }

    var remove = e.target.closest('[data-civicsupply-quote-remove]');
    if (remove) {
      delete qty[remove.getAttribute('data-civicsupply-quote-remove')];
      refresh();
    }
  });

  document.addEventListener('input', function (e) {
    if (!modal() || modal().hidden) return;

    if (e.target.matches('[data-civicsupply-quote-filter]')) { applyFilter(); return; }

    if (e.target.matches('[data-cs-qty]')) {
      var id = e.target.dataset.csVariant;
      var n = Math.max(0, parseInt(e.target.value, 10) || 0);
      if (n) qty[id] = n; else delete qty[id];
      // Patch this card only - re-syncing every input would fight the caret
      // while the customer is still typing.
      syncCard(e.target);
      syncChips();
      renderSummary();
      syncChrome();
      syncPayload();
      saveDraft();
      return;
    }

    if (e.target.matches('[data-civicsupply-qf-required]') && e.target.value.trim()) {
      e.target.classList.remove('civicsupply-qf__input--error');
    }

    // Autosave the typed details on every keystroke, so closing the modal or
    // following a product photo never loses a half-filled form.
    if (e.target.matches('[name^="contact["]')) saveFields();
  });

  // <select> (Province) fires change in every browser; input only in modern ones.
  document.addEventListener('change', function (e) {
    if (!modal() || modal().hidden) return;
    if (e.target.matches('[name^="contact["]')) saveFields();
  });

  // Select the whole quantity on focus so typing replaces rather than appends -
  // "10" after a stray click used to become "010" or "100".
  document.addEventListener('focusin', function (e) {
    if (!modal() || modal().hidden) return;
    if (e.target.matches('[data-cs-qty]')) e.target.select();
  });

  document.addEventListener('keydown', function (e) {
    if (!modal()) return;
    if (e.key === 'Escape' && !modal().hidden) {
      // On phones Esc backs out of the sheet before it closes the whole modal.
      if (sheetIsOpen()) closeSheet();
      else close();
    }
    trapFocus(e);
  });

  // EDITED 2026-08-15 - block an invalid submit at CLICK time, in the capture
  // phase, so it never reaches Shopify's captcha at all.
  //
  // WHY THIS EXISTS (Denis, 2026-08-15: "it went to captcha and then nothing
  // after that, just scrolls down and modal closes" with required fields
  // empty): Shopify injects captcha-bootstrap in <head>, so its submit hook is
  // registered long before this file runs at the end of <body>. When Shopify
  // decides to show a challenge it takes the submit over, then re-submits the
  // form PROGRAMMATICALLY via form.submit() - which does NOT fire a submit
  // event - so the bubble-phase validation below never ran and an empty quote
  // was posted anyway. The page then did a full POST + redirect, which reads as
  // "the modal closed and the screen scrolled down" (the form's action carries
  // a #CivicsupplyQuoteForm fragment, and that anchor sits at the very bottom
  // of the page, right by the Contact Us section).
  //
  // It only misfires when Shopify actually serves a challenge, which is why it
  // reproduced for Denis but never in testing.
  //
  // A click guard is the reliable place for this: no submit event exists yet,
  // so nothing downstream - captcha included - has been engaged. stopImmediate
  // Propagation keeps captcha's own click hooks out of it too.
  //
  // ⚠️ DO NOT move either listener back to the bubble phase, and do not rely on
  // e.preventDefault() in a bubble handler to stop a Shopify form - a
  // programmatic form.submit() bypasses it entirely.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-civicsupply-quote-submit]')) return;
    if (!validate()) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Capture phase as well, for the keyboard path (Enter inside a text field
  // submits without ever producing a click). Same reasoning as above: running
  // in capture puts this ahead of captcha's own submit hook.
  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'CivicsupplyQuoteForm') return;
    if (!validate()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    // Valid from here on - deliberately does NOT stop propagation, so captcha
    // still gets to run its normal flow on a genuine submission.
    syncPayload();
    // Mark the submission as ours so the post-redirect thank-you only shows for
    // quote requests, not contact-page submissions (both use the contact pipe).
    try { sessionStorage.setItem(PENDING_KEY, '1'); } catch (err) {}
    // The draft has served its purpose; don't greet them with a stale quote,
    // and don't leave contact details sitting in storage after the quote's gone.
    try { localStorage.removeItem(DRAFT_KEY); } catch (err) { memFallback = null; }
    clearFields();
  }, true);

  // ------------------------------------------------------------------- init
  function init() {
    if (!modal()) return;
    readConfig();
    // Restore typed details straight away rather than on open(), so they are
    // already in place however the modal is reached on this page load.
    loadFields();

    var posted = /[?&]contact_posted=true/.test(location.search);
    var pending = false;
    try { pending = sessionStorage.getItem(PENDING_KEY) === '1'; } catch (err) {}
    if (posted && pending) {
      // Claim this redirect as a QUOTE submission before civicsupply-contact.js
      // runs (it loads later in document order), so the contact thank-you modal
      // doesn't ALSO open on the shared ?contact_posted=true param.
      window.civicsupplyQuoteRedirect = true;
      try { sessionStorage.removeItem(PENDING_KEY); } catch (err) {}
      show('thanks');
      var url = location.pathname +
        location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '') +
        location.hash;
      history.replaceState(null, '', url);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
